module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAQCAYAAAAI0W+oAAAA20lEQVQ4T53VsRHCMAwF0P8L1qCmYgMqJoAmu9AQCiiYBCp2oaJhAzag+Jy4mDMGJ1LcRs7Ll3UOMWJJmpG8RbYyUmy1kloAGwANyYt3fwjqkG338mcEc0MFkoK4MRdUQULYIDSAuLFeqII8ABwB7AFMsmHobWMV6kGWJK+S1gBOXuwvNISkFBHsB/IiUewLiiIR7AONRTJsBeBcO7M3JKnpDja/UWy63gfvvWYk1bB5gmxM7Wus0FYY6Um2I9nmrUvYIpqkTJwlOxhiz8thMGxK8u5tV62u/JW8AL62jTaDwNwiAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/icon_arrow_top.png
// module id = 702
// module chunks = 0